'use client';

import { AccordionRoot } from '@lichtblick/photon/organisms/accordion/accordion';
import { useSearchParams } from 'next/navigation';
import { type FC, useState } from 'react';
import type { AccordionWithUrlStateProps } from './accordion-with-url-state';

const OPEN_ACCORDION_UIDS_PARAM = 'open';

const setOpenValuesInUrl = (previousValues: string[], nextValues: string[]) => {
  const url = new URL(window.location.href);

  for (const value of previousValues) {
    url.searchParams.delete(OPEN_ACCORDION_UIDS_PARAM, value);
  }

  for (const value of nextValues) {
    url.searchParams.append(OPEN_ACCORDION_UIDS_PARAM, value);
  }

  window.history.replaceState(null, '', url);
};

export const AccordionWithUrlStateClient: FC<AccordionWithUrlStateProps> = ({ children, className }) => {
  const params = useSearchParams();
  const paramsOpenValues = params.getAll(OPEN_ACCORDION_UIDS_PARAM);

  const [value, setValue] = useState(paramsOpenValues);

  const handleValueChange = (newValue: string[]) => {
    setOpenValuesInUrl(value, newValue);

    setValue(newValue);
  };

  return (
    <AccordionRoot type="multiple" value={value} onValueChange={handleValueChange} className={className}>
      {children}
    </AccordionRoot>
  );
};
